import React from 'react'
import * as R from 'remeda'

import {
  SurveyGroupAnswerOptionConditionalSelector,
  type SurveyGroupAnswerOptionConditionalSelectorProps,
} from '~/components/features/SurveyGroupAnswerOptionConditionalSelector'
import { type ConditionOperation } from '~/gql/graphql'
import { intersectionBy } from '~/utils'

import { type SurveyGroupAnswerOption } from '../utils'

export type AnswerOptionsInputProps = {
  answerOptions: SurveyGroupAnswerOption[]
  conditionOperation: ConditionOperation
  onBlur: () => void
  onChange: (value: SurveyGroupAnswerOption[]) => void
  value: SurveyGroupAnswerOption[]
}

export const AnswerOptionsInput = React.forwardRef<
  HTMLDivElement,
  AnswerOptionsInputProps
>(({ answerOptions, conditionOperation, onBlur, onChange, value }, ref) => {
  const handleChange = React.useCallback<
    EH<
      SurveyGroupAnswerOptionConditionalSelectorProps<SurveyGroupAnswerOption>,
      'onChange'
    >
  >(
    (options) => {
      onChange(
        intersectionBy(answerOptions, options, R.prop('option'), R.identity()),
      )
    },
    [answerOptions, onChange],
  )

  return (
    <SurveyGroupAnswerOptionConditionalSelector
      ref={ref}
      answerOptions={answerOptions}
      conditionOperation={conditionOperation}
      value={value.map(R.prop('option'))}
      onBlur={onBlur}
      onChange={handleChange}
    />
  )
})
